import _module from 'module.js'

class ResyncAllDevicesWarning {
  constructor (confirmationWindowWarn) {
    'ngInject'
    this.confirmationWindowWarn = confirmationWindowWarn
  }

  open (deviceCount, resyncAll, gettextCatalog) {
    const warningQuestion = gettextCatalog.getString(
      'Are you sure you want to resync all {{count}} devices?',
      { count: deviceCount }
    )

    const warningMessage = gettextCatalog.getString(
      'Resyncing multiple devices at one time can place a significant ' +
        'load on the infrastructure. For the customer, this can overwhelm network resources, cause phones ' +
        'to be unavailable, and result in poor call quality.'
    )

    const okText = gettextCatalog.getString('Resync {{count}} Devices', {
      count: deviceCount
    })

    this.confirmationWindowWarn
      .show(warningQuestion, warningMessage, okText)
      .then(resyncAll)
  }

  static factory (confirmationWindowWarn) {
    'ngInject'
    return new ResyncAllDevicesWarning(confirmationWindowWarn)
  }
}

_module.factory('resyncAllDevicesWarning', ResyncAllDevicesWarning.factory)
